var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEiffelTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 466 466",
    style: {
      enableBackground: "new 0 0 466 466"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37495E"
    },
    d: "M365.353,447.559c-74.056-120.737-101.492-245.38-104.118-366.118c-24.887,0-31.584,0-56.471,0 c-2.626,120.737-30.061,245.38-104.118,366.118c23.145,0,46.291,0,69.437,0c-0.055-1.447-0.084-5.903-0.084-7.368 c0-46.806,28.654-84.75,64-84.75s64,37.944,64,84.75c0,1.465-0.028,5.921-0.083,7.368 C320.395,447.559,342.874,447.559,365.353,447.559z M255.059,292.441h-45v-17.725c0-12.302,9.973-22.275,22.275-22.275h0.45 c12.302,0,22.275,9.973,22.275,22.275L255.059,292.441L255.059,292.441z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.206,
    y: 183,
    style: {
      fill: "#ff9a44"
    },
    width: 114.706,
    height: 20.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.059,
    y: 291.559,
    style: {
      fill: "#ff9a44"
    },
    width: 175,
    height: 21.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 444.559,
    style: {
      fill: "#ff9a44"
    },
    width: 92.5,
    height: 21.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 444.559,
    style: {
      fill: "#ff9a44"
    },
    width: 92.5,
    height: 21.441
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37495E"
    },
    d: "M233,69c-4.419,0-8-3.581-8-8V8c0-4.418,3.581-8,8-8c4.418,0,8,3.582,8,8v53 C241,65.419,237.418,69,233,69z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.766,
    y: 61,
    style: {
      fill: "#ff9a44"
    },
    width: 56.453,
    height: 21.441
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiffelTower);
export default __webpack_public_path__ + "static/media/eiffel-tower.e8870b891b445ba491bbe2ebafb25cb5.svg";
export { ForwardRef as ReactComponent };